import { DistrictModel, ProjectPhaseModel, ProjectPhaseStatus } from '../generated';

/*
    Returns a status based on related projectPhases
*/
const getDistrictStatus = (
    district: DistrictModel,
    projectPhases: ProjectPhaseModel[],
): ProjectPhaseStatus => {
    // Filter related project phases
    const filteredProjectPhases = projectPhases.filter(
        ({ districtId }) => district.id === districtId,
    );

    const statuses = filteredProjectPhases
        .map((item) => item.status)
        .filter((status, index, self) => status && self.indexOf(status) === index);

    // Return correct district status
    if (statuses.length === 1 && statuses[0]) return statuses[0];

    if (statuses.indexOf('OnSale') > -1) return 'OnSale';

    return 'InPreparation';
};

export { getDistrictStatus };
